import {createContext} from 'react'

const NotificacionesContext = createContext()

export default NotificacionesContext